import { formatGrams } from '../nutrition'
import type { MacroProgress } from '../types'

const COLOUR: Record<MacroProgress['key'], string> = {
  protein: 'var(--protein)',
  carbs: 'var(--carbs)',
  fat: 'var(--fat)',
}

/**
 * The bar is capped at 100% with an over-target colour, so an overshoot cannot render
 * past the track and quietly look like progress.
 */
export function MacroBar({ macro }: { macro: MacroProgress }) {
  return (
    <div className="macro">
      <div className="macro-top">
        <span className="macro-name">{macro.label}</span>
        <span className="macro-nums">
          {formatGrams(macro.consumedG)} / {formatGrams(macro.targetG)}
        </span>
      </div>
      <div className="track">
        <span
          style={{
            width: `${macro.fraction * 100}%`,
            background: macro.over ? 'var(--rec-low)' : COLOUR[macro.key],
          }}
        />
      </div>
      <div className={`macro-nums ${macro.over ? 'over' : ''}`}>
        {macro.over
          ? `${formatGrams(Math.abs(macro.remainingG))} over`
          : `${formatGrams(macro.remainingG)} left`}
      </div>
    </div>
  )
}
